import { createIdentifier } from '@wix/thunderbolt-ioc'
import type { INamedSignalsHandlers } from './types'

export const NamedSignalsHandlersSymbol = createIdentifier<INamedSignalsHandlers>(Symbol('NamedSignalsHandlersSymbol'))

export const name = 'namedSignalsService' as const
